import { extend } from 'flarum/common/extend';
import HeaderPrimary from 'flarum/forum/components/HeaderPrimary';
import ArticlesMenu from './components/ArticlesMenu';

// Adds an "Articles" dropdown to the header, right after champis-species'
// 'speciesMenu' (95) and before champis-forum's own 'forumsMenu' (85) in
// the same HeaderPrimary ItemList - matching champis.net's own top nav
// order (Accueil, Espèces, Articles, Forums), where "Articles" is its own
// item right after "Espèces" (not nested inside it: articles aren't
// species-specific content).
export default function addArticlesMenu() {
  extend(HeaderPrimary.prototype, 'items', function (items) {
    items.add('articlesMenu', m(ArticlesMenu, null), 90);
  });
}